module.exports = __webpack_public_path__ + "d039f52867991395b36366fe80b2bbf1.png";